export type EvaluationTemplate = {
  id: string;
  name: string;
  productName: string;
  targetUrl: string;
  taskQuery: string;
  experienceBrief: string;
  scenarioName: string;
  personaName: string;
  monitoringProfile: "generic" | "nexplay";
  responseDeadlineSeconds: number;
};

export const evaluationTemplates: EvaluationTemplate[] = [
  {
    id: "nexplay-dev",
    name: "nexplay-测试环境",
    productName: "nexplay-测试环境",
    targetUrl: "https://nextplay-dev.sandaii.cn/",
    taskQuery: "帮我创建一个拳皇类似题材的互动影游",
    experienceBrief: "面向首次创作互动影游的用户：用一句自然语言启动全自动创作，产品只询问真正阻塞的信息，在多轮中保留上下文并持续生成连贯、可编辑的角色、场景、剧情与分支，同时显示真实进度，最终到达可预览或可继续编辑的原型。",
    scenarioName: "从首页输入一个明确的互动影游创作要求，使用全自动模式提交，观察 Agent 回复与页面状态变化，直至获得可预览或可继续编辑的创作结果。",
    personaName: "第一次使用 Nexplay、希望快速生成互动影游原型，但不了解平台内部工作流的内容创作者。",
    monitoringProfile: "nexplay",
    responseDeadlineSeconds: 1800,
  },
];
